import PropTypes from 'prop-types';
import React from 'react';
import Slider from 'react-slick';
import { isStyledComponent } from 'styled-components';

import 'slick-carousel/slick/slick.css';

import CarouselPaginationContainer from './CarouselPaginationContainer';
import CarouselPagination from './CarouselPagination';
import CarouselArrow from './CarouselArrow';
import CarouselContainer from './CarouselContainer';

const customPagination = () => <CarouselPagination />;
const customPaginationContainer = (dots) => {
  return (
    <CarouselPaginationContainer>
      <ul>{dots}</ul>
    </CarouselPaginationContainer>
  );
};

const dataTestIdPrefix = 'carousel';

const Carousel = ({
  children,
  slickOptions,
  className,
  listLength,
  wrapper,
  arrowTopOffset,
  sliderRef,
  activeIndex,
  setActiveIndex,
  ...props
}) => {
  const CarouselWrapper =
    isStyledComponent(wrapper) || typeof optionContainer === 'function'
      ? wrapper
      : CarouselContainer;

  const initialOptions = {
    centerMode: true,
    infinite: true,
    dots: false,
    arrows: true,
    initialSlide: 0,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 300,
    nextArrow: (
      <CarouselArrow
        data-testid={`btn-${dataTestIdPrefix}-next-slide`}
        arrowTopOffset={arrowTopOffset}
        isShown={activeIndex !== listLength - 1}
        isInfinite={slickOptions?.infinite}
      />
    ),
    prevArrow: (
      <CarouselArrow
        data-testid={`btn-${dataTestIdPrefix}-previous-slide`}
        arrowTopOffset={arrowTopOffset}
        isNext={false}
        isShown={activeIndex !== 0}
        isInfinite={slickOptions?.infinite}
      />
    ),
    initialSlide: activeIndex,
    afterChange: (currentSlideIndex) => {
      setActiveIndex(currentSlideIndex);
    },
    appendDots: customPaginationContainer,
    customPaging: customPagination,
  };
  const settings = { ...initialOptions, ...slickOptions };
  return (
    <CarouselWrapper className={className} {...props}>
      <Slider ref={sliderRef} {...settings} {...props}>
        {children}
      </Slider>
    </CarouselWrapper>
  );
};

Carousel.propTypes = {
  children: PropTypes.any.isRequired,
  slickOptions: PropTypes.object,
  className: PropTypes.string,
  listLength: PropTypes.number,
  wrapper: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.elementType]),
  arrowTopOffset: PropTypes.number,
  sliderRef: PropTypes.oneOfType([PropTypes.func, PropTypes.elementType]),
};

Carousel.defaultProps = {
  slickOptions: {},
  arrowTopOffset: 44,
};

export default Carousel;
